<template>
    <div class="certification-root">
        <Top></Top>
        <div class="certification-body___1UbSf">
            <div class="side-menu-layout">
                <div class="content_menu">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" :class="active == 'my' ? 'ant-menu-item-selected' : ''"
                                style="padding-left: 16px;" @click="changeTab('/my','my')">
                                <a>账号概览</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'safe' ? 'ant-menu-item-selected' : ''"
                                style="padding-left: 16px;" @click="changeTab('/safe','safe')">
                                <a>安全设置</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'realname' ? 'ant-menu-item-selected' : ''"
                                style="padding-left: 16px;" @click="changeTab('/realname','realname')">
                                <a>实名认证</a>
                            </li>
                            <!--<li class="ant-menu-item" :class="active == 'information' ? 'ant-menu-item-selected' : ''"-->
                                <!--style="padding-left: 16px;" @click="changeTab('/information','information')">-->
                                <!--<a>基本资料</a>-->
                            <!--</li>-->
                            <li class="ant-menu-item" :class="active == 'api' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/api','api')">
                                <a>API管理</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_main">
                    <div class="ant-spin-nested-loading">
                        <div class="ant-spin-container">
                            <div class="ant-card pesonalKyc___UZUEa ant-card-bordered ant-card-wider-padding ant-card-padding-transition">
                                <div class="ant-card-head">
                                    <div class="ant-card-head-wrapper">
                                        <div class="ant-card-head-title">
                                            <div class="cardTitle___1SbxV">
                                                <a @click="changeRoute('/amend_deal_pwd')">
                                                    <img src="@/assets/img/left_blue.png" alt="">
                                                    返回上级
                                                </a>
                                                <span>开启提现保护</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ant-card-body">
                                    <div class="stepsContainer___QhSxY">
                                        <div class="ant-steps ant-steps-horizontal ant-steps-small ant-steps-label-vertical">
                                            <div class="ant-steps-item ant-steps-item-finish">
                                                <div class="ant-steps-item-tail ant-steps-item-tail-next"></div>
                                                <div class="ant-steps-item-icon">
                                                    <span class="ant-steps-icon">
                                                        <img src="@/assets/img/gou.png" alt="">
                                                    </span>
                                                </div>
                                                <div class="ant-steps-item-content">
                                                    <div class="ant-steps-item-title">安全验证</div>
                                                </div>
                                            </div>
                                            <div class="ant-steps-item ant-steps-item-process">
                                                <div class="ant-steps-item-tail ant-steps-item-tail-next"></div>
                                                <div class="ant-steps-item-icon">
                                                    <span class="ant-steps-icon">2</span>
                                                </div>
                                                <div class="ant-steps-item-content">
                                                    <div class="ant-steps-item-title">身份验证</div>
                                                </div>
                                            </div>
                                            <div class="ant-steps-item ant-steps-item-wait">
                                                <div class="ant-steps-item-tail"></div>
                                                <div class="ant-steps-item-icon">
                                                    <span class="ant-steps-icon">3</span>
                                                </div>
                                                <div class="ant-steps-item-content">
                                                    <div class="ant-steps-item-title">完成</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <form class="ant-form ant-form-horizontal identityForm___3TRUk credential___320dw">
                                        <div class="ant-row ant-form-item">
                                            <div class="ant-form-item-label">
                                                <label class="ant-form-item-required">证件照正面</label>
                                            </div>
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="limitText___3xZv2">请保证照片文字清晰可见，仅支持jpg、png格式，不超过4mb</div>
                                                        <span>
                                                            <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
                                                                <span class="ant-upload">
                                                                    <input type="file">
                                                                    <div>
                                                                        <img src="@/assets/img/add.png" alt="">
                                                                        <div class="uploadText___14hbj">upload</div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item">
                                            <div class="ant-form-item-label">
                                                <label class="ant-form-item-required">证件照背面</label>
                                            </div>
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="limitText___3xZv2">请保证照片文字清晰可见，仅支持jpg、png格式，不超过4mb</div>
                                                        <span>
                                                            <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
                                                                <span class="ant-upload">
                                                                    <input type="file">
                                                                    <div>
                                                                        <img src="@/assets/img/add.png" alt="">
                                                                        <div class="uploadText___14hbj">upload</div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item">
                                            <div class="ant-form-item-label">
                                                <label class="ant-form-item-required">上传手持证件照</label>
                                            </div>
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="limitText___3xZv2">请保证照片文字清晰可见，仅支持jpg、png格式，不超过4mb</div>
                                                        <span>
                                                            <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
                                                                <span class="ant-upload">
                                                                    <input type="file">
                                                                    <div>
                                                                        <img src="@/assets/img/add.png" alt="">
                                                                        <div class="uploadText___14hbj">upload</div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </span>
                                                        <div class="claim___3X-9T" style="margin-top: 19px;">
                                                            <div>
                                                                <img src="@/assets/img/zipai.png" alt="">
                                                            </div>
                                                            <div class="reminds___31rNk">
                                                                <div class="remindsTitle___3As2p">
                                                                    <img src="@/assets/img/zhuyi.png" alt="">
                                                                    请提供一张您手持护照或有照片的证件的照片。在同张照片中也要提及 winerbit.in 和显示今天日期 — 有“winerbit.in”、“今天日期”和您的签名的注释。请确保您的脸部清晰可见，且所有护照详细信息都清楚可读
                                                                </div>
                                                                <ul class="remindsList___219ks">
                                                                    <li class="remindsItem___WNP5v">
                                                                        <img src="@/assets/img/gou_other.png" alt="">
                                                                        面部清晰可见无遮挡
                                                                    </li>
                                                                    <li class="remindsItem___WNP5v">
                                                                        <img src="@/assets/img/gou_other.png" alt="">
                                                                        照片证件清晰可见
                                                                    </li>
                                                                    <li class="remindsItem___WNP5v">
                                                                        <img src="@/assets/img/gou_other.png" alt="">
                                                                        带有「winerbit.in」的文字注释
                                                                    </li>
                                                                    <li class="remindsItem___WNP5v">
                                                                        <img src="@/assets/img/gou_other.png" alt="">
                                                                        带有今天的日期（yy-mm-dd）
                                                                    </li>
                                                                    <li class="remindsItem___WNP5v">
                                                                        <img src="@/assets/img/gou_other.png" alt="">
                                                                        带有您的签名
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="submitBtn___3cgLG">
                                                            <div class="ant-btn  kc-button ant-btn-primary ant-btn-block" style="line-height:32px;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);" @click="changeRoute('/complete_deal_pwd')">
                                                                <span>提交</span>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "withdraw_protect",
        components: {
            Top, Bottom
        },
        data() {
            return {
                active: 'safe'
            }
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            }
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/certification.css";
</style>
